import React from "react";
import DropDownCourseItem from "../DropDownCourseItem";
import { Dropdown, Icon, Menu } from "antd";
import style from "./DropDownCourse.module.scss";
import { CourseListItem } from "../../../../../service/exam";

interface DropDownCourseProps {
    data: CourseListItem[];
}

export default function DropDownCourse({ data }: DropDownCourseProps) {
    const menu = (
        <Menu>
            {data.map(item => (
                <Menu.Item key={item.courseSeq + item.courseNo}>
                    <DropDownCourseItem {...item} />
                </Menu.Item>
            ))}
        </Menu>
    );

    if (data.length === 0) return <div />;
    if (data.length === 1)
        return (
            <div className={style.wrapper}>
                <DropDownCourseItem {...data[0]} />
            </div>
        );

    return (
        <Dropdown overlay={menu}>
            <div className={style.wrapper} onClick={e => e.preventDefault()}>
                <DropDownCourseItem {...data[0]} />{" "}
                <Icon type="more" className={style.icon} />
            </div>
        </Dropdown>
    );
}
